export const ACCESS_TOKEN_NAME = 'access_token'
export const AUTHORITIES_NAME = 'authorities'
export const USER_NAME = 'userName'
export const USER_ID = 'userId'
export const EXP_TOKEN = 'exp_token'
export const FILE_MERGE_MAX_SIZE = 209715200 /* 200MB */
export const LOCATION_CODE_NAME = 'location_code'
export const FULL_NAME = 'full_name'
export const USER_POSITION = 'user_position'
export const FILE_MAX_SIZE = 209715200 /* 200MB */
export const IS_CHECK_MAX_SIZE_UPLOAD = true

export const TypeSchedule = {
  File_Audio: 0,
  Internet: 1
}

export const Roles = {
  ADMIN: 'ROLE_ADMIN',
  PROVINCE: 'ROLE_MANAGER',
  DISTRICT: 'ROLE_USER',
  WARD: 'ROLE_WARD'
};

export const Authorities = {
  Central: 1,           /* Cấp trung ướng */
  Provincial: 2,        /* Cấp tỉnh */
  District: 3,          /* Cấp huyện */
  Wards: 4,             /* Cấp xã */
}

export const sourceType = {
  BIEN_TAP : 1,
  CHUYEN_DOI_VAN_BAN: 2,
  GHEP_TEP: 3,
  GHI_AM_TEP_TIN: 4
}

export const AudioHistoryType = {
  NHAN_BAN_TIN: 0, /* Nhận được bản tin */
  DA_PHAT: 1, /* Đã phát bản tin */
  DA_HUY: 3, /* Đã hủy bản tin */
  DANG_PHAT: 2, /* Đang phát bản tin */
  PHAT_LOI: 4 /* Phát lỗi bản tin */
}

export const AudioHistoryTypeList = [
  {
    key: "null",
    value: "Tất cả loại nhật ký"
  },
  {
    key: "0",
    value: "Đã gửi"
  },
  {
    key: "1",
    value: "Đã phát"
  },
  {
    key: "3",
    value: "Đã hủy"
  },
  {
    key: "2",
    value: "Đang phát"
  },
  {
    key: "4",
    value: "Phát lỗi"
  }
]

export const ScreenHistoryType = {
  NHAN_BAN_TIN: 0, /* Nhận được bản tin */
  DA_PHAT: 1, /* Đã phát bản tin */
  DA_HUY: 3, /* Đã hủy bản tin */
  DANG_PHAT: 2, /* Đang phát bản tin */
  PHAT_LOI: 4 /* Phát lỗi bản tin */
}

export const ScreenHistoryTypeList = [
  {
    key: "null",
    value: "Tất cả loại nhật ký"
  },
  {
    key: "0",
    value: "Đã gửi"
  },
  {
    key: "1",
    value: "Đã phát"
  },
  {
    key: "2",
    value: "Đang phát"
  },
  {
    key: "3",
    value: "Đã hủy"
  },
  {
    key: "4",
    value: "Phát lỗi"
  }
]

export const TypeArea = {
  TOAN_MAN_HINH: 0,
  VUNG_THONG_BAO: 1,
  VUNG_TRAI: 2,
  VUNG_PHAI: 3
}

export const APP_CODE = 'HTTTN';

export const CLIENT_ID = '6c3c566e7f1f222c7a15a50cbc57d0cd183b35b8232ad9cf67d3df82c71956af';
